// Corridas before this date predate reliable hour capture on productions: their
// kilos count but their hours read as 0, which would inflate any kg/hr ratio
// (the numerator grows, the denominator does not). It is the ONE window boundary
// every production-performance surface reads from — the Rendimiento page, the
// grading dialog, the Producción list flags, the upsert form's Rendimiento tab,
// and the planning board's prediction — and the default a movable "Desde" falls
// back to.
//
// It lived in helpers/formatting/format-date.ts until 2026-08-11, which was the
// wrong home: this is a fact about how hours are captured on productions, not
// about how a date is formatted, and it belongs beside the grading rules
// (performance-flags.ts, rates-cache.ts) that lean on it. Mirror of the backend
// HOURLY_DATA_EPOCH in production-performance.service.ts — keep the two in step.
export const HOURLY_DATA_EPOCH = '2026-01-01';

// A production shift is 8 hours. The floor and planners talk in "bultos por
// turno", so every bultos/hr figure on the Rendimiento page also shows this
// projection (bultos/hr × 8) — the number they used to compute by hand outside
// the app. A single constant so the weekly audit and the machine/product tables
// cannot drift apart on what a turno is.
export const SHIFT_HOURS = 8;
